export const langPageSelect = {
  fr: {
    //display1: 'Affichage des éléments ',
    display1: `Eléments `,
    display2: ' à ',
    display3: ' sur ',
    //display4: ' éléments',
    display4: ``,
    displayPrevious: '<',
    displayNext: '>',
    filteredFrom: `filtrés de `,
    //filteredTo: ` éléments au total`,
    filteredTo: ``,
  },
  eng: {
    //display1: 'Viewing items ',
    display1: `Items `,
    display2: ' to ',
    display3: ' on ',
    //display4: ' elements',
    display4: ``,
    displayPrevious: 'Previous',
    displayNext: 'Next',
    filteredFrom: `filtered from `,
    //filteredTo: ` items in total`,
    filteredTo: ``,
  },
}
